export const LANGUAGES = [
    'Arabic', 'Bengali', 'Bulgarian', 'Burmese', 'Chinese (Simplified)',
    'Chinese (Traditional)', 'Croatian', 'Czech', 'Danish', 'Dutch', 'English',
    'Estonian', 'Finnish', 'French', 'German', 'Greek', 'Gujarati', 'Hebrew',
    'Hindi', 'Hungarian', 'Indonesian', 'Italian', 'Japanese', 'Javanese',
    'Kannada', 'Khmer', 'Korean', 'Latvian', 'Lithuanian', 'Malay', 'Marathi',
    'Nepali', 'Norwegian', 'Persian', 'Polish', 'Portuguese', 'Punjabi',
    'Romanian', 'Russian', 'Serbian', 'Sinhala', 'Slovak', 'Slovenian',
    'Somali', 'Spanish', 'Swahili', 'Swedish', 'Tagalog', 'Tamil', 'Telugu',
    'Thai', 'Turkish', 'Ukrainian', 'Urdu', 'Uzbek', 'Vietnamese',
]
